module.exports = __webpack_public_path__ + "img/manufacture@2x.9550767.webp";